import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {
  @Input('form') form:FormGroup;
  toExistingGroup:FormControl;
  personInChargeEmail:FormControl;
  constructor(
  ) { }

  ngOnInit() {
    this.personInChargeEmail = this.form.get('personInCharge.personInChargeEmail') as FormControl;
    this.toExistingGroup = this.form.get('toExistingGroup') as FormControl;
  }

}
